import React from 'react';
import "./dashboard__type2.css"
import './DashboardType7.scss';
import {
  BgHeartNiko, ChartIcon,
  EnvelopeIconAutoC,
  NotificationBellIconAutoC,
  PersonIconAutoC,
  TriangleSign
} from "../../../Assets/svg";
import numeric from "../../../utils/NumericFunction";
import utilsFunction from "../../../utils/utilsFunction";
import CommaSeparator from "../../../utils/CommaSeparator";
import {ReactTabulator} from "react-tabulator";
import TabulatorTableOptions from "../../../utils/TabulatorTableOptions";
import AdminCharts from "../../../Components/AdminReport/AdminChart/AdminChart";
import chart from "../../../Components/Chart";
import IconViewer from "../../../Assets/svg/IconViewer";
import axios from "axios";
import {toast} from "react-toastify";
import SampleChart from "../../../Components/Report/ReportBuilder/SampleChart";
import {useNavigate} from "react-router-dom";
import MyReChart from "../../../Components/Rechart/MyReChart";

const DashboardType3 = (props) => {
  let {dashboardComponentData} = props;

  // dashboardComponentData = dddd



  //debugger

  // //debugger

  const navigateTo = useNavigate()

  try {
    return (<>
      <hr/>
      {JSON.stringify(dashboardComponentData) === JSON.stringify({}) ? <>در حال بارگزاری</> : <>
        <div className={"dashboard__type2"}
             style={{
               background: "#f8f8f8", padding: 10,
               borderRadius:10
             }}
        >
          {/*<div className={"d-flex justify-content-between align-items-center"}>*/}

          {/*  <div className={"mx-2 my-2"}>*/}
          {/*    <div className={"text__color__like__black"}><TriangleSign color={"#8DCDDA"}/>*/}
          {/*      <span className={"px-1"}> {"داشبورد "} </span>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*  <div className={"mx-2 my-2 d-flex"}>*/}
          {/*    <EnvelopeIconAutoC/>*/}
          {/*    <PersonIconAutoC/>*/}
          {/*    <NotificationBellIconAutoC/>*/}
          {/*    /!*<div className="mx-2 my-2" onClick={logOutHandler}>*!/*/}
          {/*    /!*  <i className="fas fa-power-off"></i>*!/*/}
          {/*    /!*</div>*!/*/}
          {/*  </div>*/}

          {/*</div>*/}

          <div className={"d-flex flex-wrap"}>
            <div className={" col-sm-12 col-md-9 "}>
              <div className={"text__color__like__black "} style={{

                display: 'grid', // 'grid-template-columns': 'repeat(4, 1fr)',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',

                gridGap: '10px',
              }}>
                {dashboardComponentData?.panelData.map((v, index) => <div key={index}
                                                                          className="item__card__data position-relative">
                  <div className={"position-absolute"} style={{}}>
                    <IconViewer icon={v.icon}/>
                  </div>
                  <div
                    className={"position-absolute"}
                    style={{left: 20, bottom: 10, fontSize: '10px'}}> {v.text}</div>
                  <div
                    className={"position-absolute"}
                    style={{left: 20, bottom: 30, fontSize: '24px',}}>{numeric.e2p(CommaSeparator(v.number))}
                  </div>
                </div>)}
              </div>

              <div className={"mx-2 mt-5"}>
                <div className={"text__color__like__black"}><TriangleSign color={"#8DCDDA"}/>
                  <span className={"px-1"}>گزارشات</span>
                </div>
              </div>

              <div>
                {/*<ReactTabulator*/}
                {/*  columns={dashboardComponentData.table.columns}*/}
                {/*  data={dashboardComponentData.table.data}*/}
                {/*  // events={{rowClick: rowClickHandler}}*/}
                {/*  options={TabulatorTableOptions.style4}*/}
                {/*/>*/}
                <div className={"d-flex justify-content-around align-items-center w-100"}>
                    <div className={"w-100"}>
                      <MyReChart
                       data={dashboardComponentData.taxiChart}
                      />
                    </div>

                </div>
              </div>
            </div>
            <div className={" col-sm-12 col-md-3 "}>

              <div className={"d-flex flex-column justify-content-around"}>
                {/*{dashboardComponentData.chart.map((v, index) =>*/}
                {/*  <div key={index + ""} className={" rounded pb-5 px-1"}*/}
                {/*  >*/}
                {/*    <AdminCharts*/}
                {/*      type={v.type}*/}
                {/*      title={v.title}*/}
                {/*      options={v.options}*/}
                {/*      data={v.data}*/}
                {/*      // className={props.className}*/}
                {/*      // sum={sumOfData[i]}*/}
                {/*      hasBorder={false}*/}
                {/*      hasPrint={false}*/}
                {/*    />*/}

                {/*  </div>*/}
                {/*)}*/}
                <div className={"w-100"}>
                  <button className={"w-100 p-1 theme1__btn"}
                  onClick={()=>{
                    navigateTo("/map")
                  }}
                  > مشاهده نقشه</button>
                </div>
                <div className={" d-flex justify-content-between align-items-center p-2"}>

                  <div>
                    <TriangleSign color={"#8DCDDA"}/>


                    <span className={"px-1"}>
                     {/*{dashboardComponentData.lastNews.title }*/}
                      آخرین وضعیت
                    </span>
                  </div>
                  <div>
                    {/*{dashboardComponentData.lastNews.date}*/}
                    {numeric.e2p("1402/01/22")}
                  </div>
                </div>

                <div className={"d-flex flex-column justify-content-start align-items-center  "}>
                  {dashboardComponentData?.leftPart?.map((v, index) => {

                    //debugger
                    return <div style={{
                      width: 280,
                      height: 111,
                      background: 'white',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
                      borderRadius: '10px',
                      margin: "0 0 10px 0"
                    }}
                                className={"d-flex  flex-wrap justify-content-around align-items-center"}
                    >
                      <div>

                        <div className={"d-flex flex-wrap"}>
                          <div
                            style={{width: 75, height: 75, background: "gray", borderRadius: 15, overflow: "hidden"}}>
                            <img style={{objectFit: 'cover'}} src={v.url} alt={""}/>
                          </div>
                          <div
                            style={{
                              textWrap: 'balance', marginRight: 5, width: 100,
                            }}
                            className={"d-flex flex-wrap flex-column justify-content-center  "}
                          >
                            <div style={{
                              fontSize: 14, // whiteSpace: 'nowrap',
                              // overflow: 'hidden',
                              // textOverflow: 'ellipsis',

                            }}>{v.title}</div>
                            <div style={{fontSize: 12,}}>{numeric.e2p(v.count)} نفر</div>
                          </div>

                        </div>

                      </div>
                      <div style={{marginLeft: 5, fontSize: 14}}> {numeric.e2p(v.amount)}</div>

                    </div>
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>}
    </>);
  } catch (error){
    return <>{error.toString()}</>
  }
};

export default DashboardType3;
